import MarkdownGithub from "components/markdown/MarkdownGithub";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";

import ModuleVersionScrollableWrapper from "../components/ScrollableWrapper";
import ModuleVersionPageIntoTitle from "../components/PageIntoTitle";

type ModuleVersionReadmeProps = {
  content: string | undefined;
};

const ModuleVersionReadme = ({ content }: ModuleVersionReadmeProps) => {
  return (
    <>
      <PageInfoHeaderWrapper>
        <ModuleVersionPageIntoTitle
          title="Readme"
          tooltip="Module documentation generated based on your README.md file."
        />
      </PageInfoHeaderWrapper>
      <ModuleVersionScrollableWrapper surfaceColor="primary">
        <MarkdownGithub markup={content || "No readme available"} />
      </ModuleVersionScrollableWrapper>
    </>
  );
};

export default ModuleVersionReadme;
